// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__x6Hl0","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__45Ome"};